/// <amd-module name="Comments/Thread/CommentThread" />
export { CommentThread } from "./Components/CommentThread";
export { ICommentThreadProps } from "./Components/CommentThread.Props";
